// RUN 13 FASE 3 P9 — film-data-saver (fichero NUEVO, sin cablear a ProductFilm).
// Research 2026: web.dev LCP 2026 + Network Information API (`Save-Data` /
// `effectiveType`) + `prefers-reduced-motion` (ya respetado en ProductFilm.tsx:
// extender el mismo gesto al ahorro de datos). El cableado al IO nº1 de
// ProductFilm.tsx espera a FASE 2 (archivo caliente) — este módulo es puro.

/** Hint de red mínimo necesario para decidir póster vs vídeo. */
export interface FilmNetworkHint {
  readonly saveData?: boolean;
  readonly effectiveType?: string;
}

/** effectiveTypes que cuentan como red 2G (MDN NetworkInformation). */
const SLOW_EFFECTIVE_TYPES = new Set(["slow-2g", "2g"]);

/**
 * true → mostrar el póster `.webp` (~46 KB) y NO montar el `<video>` (~5 MB).
 * Matriz: `Save-Data:on → póster siempre` / `effectiveType:2g|slow-2g → póster`
 * / resto intacto (incluido hint vacío o effectiveType desconocido).
 * Pura: no toca DOM ni window (el lector `readFilmNetworkHint` lo hace).
 */
export function shouldDeferFilm(
  hint: FilmNetworkHint | null | undefined,
): boolean {
  if (!hint) return false;
  if (hint.saveData === true) return true;
  const et = (hint.effectiveType ?? "").trim().toLowerCase();
  if (!et) return false;
  return SLOW_EFFECTIVE_TYPES.has(et);
}

interface NavigatorWithConnection {
  readonly connection?: {
    readonly saveData?: boolean;
    readonly effectiveType?: string;
  } | null;
}

/**
 * Lee el hint desde un navigator (inyectable para tests; por defecto el
 * global si existe). Nunca lanza: sin API → `{}` (vídeo intacto).
 */
export function readFilmNetworkHint(
  nav?: NavigatorWithConnection | null,
): FilmNetworkHint {
  try {
    const source =
      nav ??
      (typeof navigator !== "undefined"
        ? (navigator as NavigatorWithConnection)
        : null);
    const conn = source?.connection;
    if (!conn) return {};
    return {
      ...(typeof conn.saveData === "boolean"
        ? { saveData: conn.saveData }
        : {}),
      ...(typeof conn.effectiveType === "string"
        ? { effectiveType: conn.effectiveType }
        : {}),
    };
  } catch {
    return {};
  }
}
